export default __webpack_public_path__ + "static/media/mobile_beehive_report_en.bbcdd4b4.png";